import { css } from 'styled-components';

import { elevations } from '@ge/tokens';

export default css`
  .highcharts-tooltip-container {
    z-index: ${elevations.P101} !important;
  }
`;
